import React from 'react';
import './About.css';
import '../components/universal.css';

export default function About() {
  return (
    <div className="about-root">
      {/* Jumbotron */}
      <section className="about-jumbotron">
        <div className="about-jumbo-content">
          <h1 className="about-jumbo-title">About HPFS</h1>
        </div>
      </section>

      {/* Experience Banner */}
      <div className="about-experience-banner fade-in">
        <span>25 years of people's experience</span>
      </div>

      {/* Main Two-Column Section */}
      <section className="about-main-section fade-in">
        <div className="about-main-left">
          <h2 className="about-main-title">Who are we</h2>
          <p className="about-main-desc">
            HPFS Australia is an Australian-based Manufacturing company supplying high-quality instrumentation valves, fittings, and engineered flow control solutions to customers across Australia and international markets. We are a Sister Concern of HP Valves & Fittings India Private Limited, a globally recognized manufacturer with over two decades of experience in precision engineering and flow control systems. Through this strategic partnership, HPFS brings together local presence and support in Australia with world-class manufacturing, testing, and certifications. Our focus is on delivering reliable, compliant, and cost-effective solutions that meet international standards while supporting our customers with responsive service, technical expertise, and dependable supply.
          </p>
          <div className='d-flex' style={{ gap: '10px' }}>
            <button className="uni-btn"><i className="fas fa-download" aria-hidden="true"></i> Catalogue</button>
            <button className="uni-btn">Contact us</button>
          </div>
        </div>
        <div className="about-main-right">
          <img
            className="about-float-img img1"
            src="https://www.oemupdate.com/wp-content/uploads/2024/04/Oil-Gas-Pipes.jpg"
            alt="Oil & Gas Pipes"
            loading="lazy"
          />
          <img
            className="about-float-img img2"
            src="https://media.industrialinfo.com/news/img/webp/iir_industry_news_oil_gas_transmission_article_thumbnail_01.webp"
            alt="Oil & Gas Transmission"
            loading="lazy"
          />
          <img
            className="about-float-img img3"
            src="https://www.genesisenergy.com/sites/default/files/styles/medium_ckeditor/public/2022-10/2.1.1_SEKCO_CRUDE_OIL.jpg?itok=AYluzh-S"
            alt="Crude Oil"
            loading="lazy"
          />
        </div>
      </section>


      <div className='p-3'>
        <div className='row fade-in pillars' style={{ gap: 24 }}>
          
          <div className='col pillars-col'>

            <i className="fas fa-bullseye fa-2x" aria-hidden="true"></i>
             <div className='text-left' >
            <h3>Our Mission</h3>
            <p>We are committed to delivering quality and reliable Valves exceeding customer expectations whilst prioritising Safety and Environment Sustainability</p></div>
          </div>
        
        <div className='col pillars-col'>

          <i className="fas fa-eye fa-2x" aria-hidden="true"></i>
          <div className='text-left' >
            <h3>Our Vision</h3>
            <p>To be Global Leader in Valve manufacturing and supply renowned for exceptional quality innovative solution and unwavering commitment to customer satisfaction.</p>
          </div>
        </div>

          <div className='col pillars-col'>
            <i className="fas fa-heart fa-2x" aria-hidden="true"></i>
            <div className='text-left' >
              <h3>Our Values</h3>
              <p>Our core values shape every decision we make. We prioritise respect, integrity, teamwork, and customer focus while maintaining transparency and trust. Above all, we are committed to quality—doing it right the first time—ensuring excellence in our services, products, and relationships.</p></div>
          </div>
        </div>


      </div>


      <div className='p-3 partnership-section fade-in'>
        <div className='row p-3'>
          <div className='col-8  fade-in' style={{ textAlign: 'left' }}>
            <h2 className='sec-title'>Our Partnership</h2>
            <span className='about-main-desc'><a href="https://hpvalvesindia.com" target="_blank" rel="noopener noreferrer">HP VALVES & FITTINGS INDIA PRIVATE LIMITED</a>, was established in the year of 2000, We are Integrated Management System (IMS) Certified Company (ISO 9001:2015, ISO 14001:2015, ISO 45001:2018) for the scope of Design, Manufacture, Testing and Supply of Instrumentation Tube Fittings, Pipe Fittings, High Pressure Fittings, Orbital Weld Fittings, O-Ring Face Seal Fittings, Sealant Injection Grease Fittings, Instrument Valves, Manifold Valves, Needle Valves, Ball Valves, Non Return Valves, High Pressure Valves, Pressure Relief Valves, Globe Valves, Gate Valves, Single Block & Bleed Valves, Double Block & Bleed Valves, Mono-Flange & Mono-Block Valves, Sampling Probes & Injection Quills, Sampling Pots, Condensate Pots, Pressure Vessels, Air Filter Regulators, Air Distribution Headers, Syphons, Flushing Rings, Thermowells, Pre-Fab Instrument Hook-up, Flanges, Pipes, Tubes, Tube Clamps, Erection Materials and Custom Build Specialized Engineering Components & Assemblies
              Led by its founder and Managing Director, Mr. HARI, who brings over 30 years of industry experience, HP Valves & Fittings has built a strong global reputation for quality, engineering excellence, and ethical business practices.
              </span>
            <div className='about-main-desc'>
              <p>
                To ensure the timely and efficient accessibility of premium quality products, we have established facilities with:
              </p>
              <ul className='facilities-list'>
                <li>Latest modern machineries</li>
                <li>In-house state-of-the-art lab facility</li>
                <li>Modern inspection equipments</li>
                <li>Industry 4.0 shop floor digitization</li>
                <li>8-axis multi-axis machining centre</li>
                <li>In-house Research &amp; Development centre</li>
                <li>
                  In-house sophisticated testing facilities like low emission, vacuum test, cryogenic test,
                  high pressure hydro &amp; high pressure gas test
                </li>
                <li>Latest design applications</li>
              </ul>
              <div className='anniversary-badge'>
                <div className='anniversary-years'>25 YEARS</div>
                <div className='anniversary-text'>ANNIVERSARY 2000 - 2025</div>
              </div>
            </div>
          </div>
          <div className='col-4  fade-in' style={{ textAlign: 'center' }}>
          <h2>India Map</h2>
          </div>
        </div>

      </div>

        </div>
    
      
  );  
}
